import styled from '@emotion/styled';
import { Combobox, ComboboxInput, ComboboxOptions } from '@headlessui/react';

import { SearchIcon } from '../../icons/SearchIcon';
import { Button } from '../Button/Button';

export const Form = styled.form`
  width: 100%;
  display: flex;
  gap: var(--spacing-8);
`;

export const DestinationField = styled(Combobox)`
  position: relative;
  width: 100%;
`;

export const Field = styled.div`
  position: relative;
  width: 100%;
`;

export const Icon = styled(SearchIcon)`
  position: absolute;
  top: calc(var(--spacing-12) + var(--spacing-2));
  left: var(--spacing-12);
  pointer-events: none;
`;

export const Input = styled(ComboboxInput, {
  shouldForwardProp: (prop) => prop !== 'isWhitelabel',
})<{ isWhitelabel?: boolean }>`
  background: var(--color-white);
  border-radius: var(--border-radius-m);
  color: var(--color-secondary-40);
  padding: var(--spacing-12) var(--spacing-12) var(--spacing-12)
    var(--spacing-44);
  width: 100%;
  margin: 0;
  outline: none;
  border: solid 1px
    ${({ isWhitelabel }) =>
      isWhitelabel ? 'var(--color-secondary-85)' : 'transparent'};
  box-shadow: var(--elevation-10);
`;

export const Dropdown = styled(ComboboxOptions)`
  width: var(--input-width);
  background: var(--color-white);
  border-radius: var(--border-radius-m);
  box-shadow: var(--elevation-30);
  --anchor-gap: var(--spacing-4);
  z-index: 10;

  &:empty {
    visibility: hidden;
  }
`;

export const SearchButton = styled(Button)`
  box-shadow: var(--elevation-10);
`;
